export const TEST_IDS = {
  SELECT_ALL: `FLEET_TABLE_SELECT_ALL`,
  SELECT_SINGLE: `FLEET_TABLE_SELECT_SINGLE`,
  LOADING: `FLEET_TABLE_LOADING`,
  FILTER: `FLEET_FILTER`,
  ALL: `ALL`,
  SCHEDULED: `SCHEDULED`,
  ON_COVER: `ONCOVER`,
  OFFCOVER: `OFFCOVER`,
  SEARCH: {
    field: `search_field`,
    button: `search_button`,
  },
}
